import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { TransactionTypesService } from 'src/app/configuration/transaction-types/transaction-types.service';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { ViewsService } from 'src/app/core/view/views.service';
import { LoginService } from 'src/app/login/login.service';
import { TransactionsDetailComponent } from '../transactions-detail/transactions-detail.component';
import { TransactionsService } from '../transactions.service';

@Component({
  selector: 'app-transactions-list',
  templateUrl: './transactions-list.component.html',
  styleUrls: ['./transactions-list.component.scss']
})
export class TransactionsListComponent implements OnInit {
  @ViewChild("view") public view: ViewComponent;
  public transactionsFilters: any = {};
  public transaction_type_id;
  public transactionType;
  public isViewInit: boolean = false;
  constructor(
    private transactionsService: TransactionsService,
    private transactionTypesService: TransactionTypesService,
    private dialogService: DialogService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private coreDialogService: CoreDialogService,
    private messageService: MessageService,
    private loginService: LoginService,
    private viewsService: ViewsService,
  ) {
  }

  ngOnInit(): void {
    //this.transactionsFilters = Object.assign(this.transactionsFilters, {userId: localStorage.userId, hasPermission: this.loginService.hasPermission("TRANSACTIONS_ALL")});
    this.transactionsFilters.responsible_id = (!this.loginService.hasPermission("TRANSACTIONS_SUPERADMIN") ? parseInt(localStorage.getItem("userId")) : null);
    //console.log(this.loginService.hasPermission("TRANSACTIONS_SUPERADMIN"), this.transactionsFilters.responsible_id);
    this.transaction_type_id = this.activatedRoute.snapshot.params.transaction_type_id;
    if (this.transaction_type_id) {
      this.getTransactionType();
    }

  }
  ngAfterViewInit() {
    Promise.resolve(null).then(() => this.isViewInit = true);
  }

  getTransactionType() {
    this.transactionTypesService.get(this.transaction_type_id).subscribe(
      data => {
        this.transactionType = data;
      }
    );
  }
  editTransaction(transaction) {
    var id = transaction?.id;
    this.router.navigate(['/transactions/', this.transaction_type_id, (id ? id : 0)]);
    /*const ref = this.dialogService.open(TransactionsDetailComponent, {
      data: {
        id: transaction ? transaction.id : null,
        transaction_type_id: this.transaction_type_id
      },
      //header: transaction ? "Detalles de la " + this.view.getEntityBaseName() + "" : "Nueva " + this.view.getEntityBaseName() +"",
      width: '70%',
    });
    ref.onClose.subscribe((data: any) => {
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      this.view.fireEvent("transactions.list.results", "reload");
    });*/
  }

  delete(transaction) {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar la " + this.view.getEntityBaseName() + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.transactionsService.delete(transaction.id).subscribe(
          data => {
            this.messageService.add({ severity: 'success', detail: "Borrada correctamente" });
            this.view.fireEvent("transactions.list.results", "reload");
          },
          error => {
            this.messageService.add({ severity: 'error', detail: error.error.title });
          }
        );
      },
      reject: () => { }
    });
  }

  search() {
    //this.transactionsFilters = Object.assign(this.transactionsFilters, {userId: localStorage.userId, hasPermission: this.loginService.hasPermission("TRANSACTIONS_ALL")});
    this.transactionsFilters = Object.assign(this.transactionsFilters, { is_page_principal: true });
    this.view.fireEvent("transactions.list.results", "reload");
  }

  onEvent(event: any) {

    if (event.component == "transactions.list.filters") {
      if (event.event == "action" && event.action.name == "search") this.search();
    } else if (event.component == "transactions.list.results") {
      if (event.event == "dblclick") this.editTransaction(event.data);
      if (event.event == "action" && event.action.name == "add") this.editTransaction(null);
      if (event.event == "action" && event.action.name == "edit") this.editTransaction(event.data);
      if (event.event == "action" && event.action.name == "delete") this.delete(event.data);
    }
  }
}
